var _excluded = ["label", "labelClass", "id"];
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
import { Container } from "reactstrap";
var Switch = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var label = _ref.label,
    labelClass = _ref.labelClass,
    id = _ref.id,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", {
    className: "form-check form-switch switch"
  }, /*#__PURE__*/React.createElement("input", Object.assign({
    style: {
      minWidth: '50px'
    },
    className: "form-check-input me-2 mt-0",
    type: "checkbox",
    role: "switch",
    id: id,
    ref: ref
  }, rest)), /*#__PURE__*/React.createElement("label", {
    className: "form-check-label ".concat(labelClass),
    htmlFor: id
  }, label));
});
Switch.defaultProps = {
  id: 'customSwitch',
  labelClass: 'text-muted'
};
export default Switch;